import * as echarts from 'echarts/core';
import { GeoComponent, VisualMapComponent, TooltipComponent, GridComponent, LegendComponent } from 'echarts/components';
import {
  ScatterChart,
  MapChart,
  LineChart,
  BarChart,
  PieChart,
  HeatmapChart,
  FunnelChart,
} from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import usGeoJson from './us-states.json';

export {
  BRAND_COLOR,
  COLOR_PALETTE,
  USER_ROLE_COLORS,
  USER_ROLE_LABELS,
  GRADIENT_BANNER,
} from './analytics-constants';

echarts.use([
  GeoComponent,
  VisualMapComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  ScatterChart,
  MapChart,
  LineChart,
  BarChart,
  PieChart,
  HeatmapChart,
  FunnelChart,
  CanvasRenderer,
]);

// ECharts registerMap expects GeoJSONCompressed which has deeply nested generics
// that don't align with raw JSON imports — no structural cast can satisfy it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
echarts.registerMap('USA', usGeoJson as any);

export const baseChartOptions = {
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  tooltip: {
    trigger: 'axis' as const,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderColor: '#e5e7eb',
    borderWidth: 1,
    textStyle: { color: '#374151', fontSize: 13 },
  },
};

export { echarts };
